/**
 * Quick Share permission ids used by the stream selection menu.
 * Kept local to avoid importing generated API permission maps.
 */
export const quickSharePermissions = {
  QuickShare_Share: 'quick-share:quick-share:share',
} as const;
